export enum EnquiresTabEnum {
    Draft = 'Draft',
    EnquiryValidation = 'Enquiry Validation',
    Review = 'Review',
    Withdrawn = 'Withdrawn',
    Archived = 'Archived',
    AwaitingMyAction = 'Awaiting My Action',
}
